import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { class: "dialog-plant-create__grid" }
const _hoisted_5 = { style: {"height":"calc(100vh - 300px)"} }
const _hoisted_6 = { class: "mr-3" }
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = {
  class: "p-field-label",
  for: "plantname"
}
const _hoisted_9 = {
  for: "name",
  class: "fs-13 label-error"
}
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = {
  class: "p-field-label",
  for: "country"
}
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  class: "p-field-label",
  for: "address"
}
const _hoisted_14 = { class: "p-field mr-3 mb-4" }
const _hoisted_15 = { class: "p-field-label mb-4 ml-3" }
const _hoisted_16 = { class: "p-field" }
const _hoisted_17 = { class: "p-field-label" }
const _hoisted_18 = { class: "p-field-with-button" }
const _hoisted_19 = { class: "bt-icon bt-icon--xs" }
const _hoisted_20 = { class: "ml-2" }
const _hoisted_21 = { class: "menu-filters mt-3" }
const _hoisted_22 = { class: "menu-filters__buttons list-unstyled p-select-button" }
const _hoisted_23 = { class: "p-button-label" }
const _hoisted_24 = {
  key: 0,
  class: "bt-icon bt-icon--2xs p-button-icon-hidden"
}
const _hoisted_25 = { class: "ml-3 bt-icon bt-icon--2xs" }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_ElScrollbar, null, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.PlantNameUpper")), 1),
                  _createVNode(_component_InputText, {
                    id: "plantname",
                    type: "text",
                    class: ["w-100", { 'input-error': !_ctx.isValidName }],
                    modelValue: _ctx.plant.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.plant.name = $event))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_9, _toDisplayString(_ctx.invalidNameReason), 1)
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.PlantCountry")), 1),
                  _createVNode(_component_Dropdown, {
                    id: "country",
                    modelValue: _ctx.plant.country,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.plant.country = $event)),
                    options: _ctx.countries,
                    optionLabel: "name",
                    optionValue: "code",
                    class: "w-100"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResource.HomeAddressUpper")), 1),
                  _createVNode(_component_InputText, {
                    id: "address",
                    type: "text",
                    class: "w-100",
                    modelValue: _ctx.plant.address,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.plant.address = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResource.PlantIcon")), 1),
                  _createVNode(_component_SelectButton, {
                    modelValue: _ctx.plant.icon,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.plant.icon = $event)),
                    options: _ctx.images,
                    optionLabel: "value",
                    optionValue: "value",
                    class: "p-selectbutton--blocks p-selectbutton--img-only pl-3"
                  }, {
                    option: _withCtx((slotProps) => [
                      _createVNode("img", {
                        class: "automation",
                        src: slotProps.option.imageURLs[0],
                        srcset: 
                                            slotProps.option.imageURLs
                                                .length === 1
                                                ? `${slotProps.option.imageURLs[0]}`
                                                : `${slotProps.option.imageURLs[0]}, ${slotProps.option.imageURLs[1]} 2x, ${slotProps.option.imageURLs[2]} 3x`
                                        ,
                        alt: "img"
                      }, null, 8, ["src", "srcset"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("AppResource.PlantGroups")), 1),
          _createVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addTag && _ctx.addTag(...args)), ["prevent"]))
          }, [
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_InputText, {
                type: "text",
                placeholder: _ctx.$t('newPlantDialog.insertGroup'),
                class: "w-100",
                modelValue: _ctx.newTagName,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.newTagName = $event))
              }, null, 8, ["placeholder", "modelValue"]),
              _createVNode(_component_Button, {
                class: "p-button-outlined p-button-rounded p-button-field",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createVNode("span", _hoisted_19, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                      "aria-label": "icon-plus-outline"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                ]),
                _: 1
              })
            ])
          ], 32),
          _createVNode("div", _hoisted_21, [
            _createVNode("ul", _hoisted_22, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tempTags, (tag) => {
                return (_openBlock(), _createBlock("li", {
                  class: ["p-button has--hidden-icon pr-3", { 'p-highlight': _ctx.isTagSelected(tag) }],
                  key: tag.key,
                  onClick: ($event: any) => (_ctx.toggleTagSelection(tag))
                }, [
                  _createVNode("span", _hoisted_23, [
                    _createTextVNode(_toDisplayString(tag.value) + " ", 1),
                    (_ctx.isTagSelected(tag))
                      ? (_openBlock(), _createBlock("span", _hoisted_24, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                            require('@/assets/images/icons/icon-close.svg')
                                        ,
                            "aria-label": "icon-close"
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_25, [
                      (!_ctx.isTagSelected(tag))
                        ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                            key: 0,
                            src: 
                                            require('@/assets/images/icons/icon-add.svg')
                                        ,
                            "aria-label": "icon-close"
                          }, null, 8, ["src"]))
                        : _createCommentVNode("", true),
                      (_ctx.isTagSelected(tag))
                        ? (_openBlock(), _createBlock("span", _hoisted_26, "✓"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 10, ["onClick"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ], 64))
}